import { AppButton } from 'components';
import { useState, useEffect, memo } from 'react';
import { Link } from 'react-router-dom';
import * as AppPics from 'assets/images';
import useManageChapterQuiz from 'hooks/API/useManageChapterQuiz';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';

function ManageQuiz({ courseID, chapterID, selectedQuiz }) {
  const [editMode, setEditMode] = useState(false);
  const [quizName, setQuizName] = useState('');
  const [deleteSModal, handleDeleteSModal] = useState({ show: false, data: {} });

  const { mutate, isLoading } = useManageChapterQuiz({ courseID });

  useEffect(() => {
    if (selectedQuiz?.name) setQuizName(selectedQuiz?.name || '');
  }, [selectedQuiz?.name]);

  function handleModification(body = {}) {
    if (isLoading) return;
    if (!quizName) return;

    mutate({ ...body, name: `${quizName}`.trim(), chapterID, quizID: selectedQuiz._id });
    setEditMode(false);
  }

  function closeSModal() {
    handleDeleteSModal({ show: false, data: {} });
  }

  return (
    <>
      <BasicDelete
        open={deleteSModal.show}
        closeModal={closeSModal}
        Header="Delete Quiz"
        handleConfirmation={() => {
          handleModification({ quizID: deleteSModal.data?._id, type: 'DELETE' });
          closeSModal();
        }}
      />
      <div className="row m-4">
        <div className="col-md-10 col-lg-10 col-sm-12">
          <div className="lessonWrap lessonWrap--border saved quizGrabHandleID">
            {true && (
              <>
                <div className="lessonWrap__text">
                  {!editMode && <span className="lessonWrap__name">{quizName}</span>}
                  {editMode && (
                    <input
                      type="text"
                      value={quizName}
                      onChange={(event) => setQuizName(event.target.value)}
                    />
                  )}
                  {!editMode && (
                    <AppButton
                      variantClass="lessonWrap__btn"
                      title="Edit"
                      onClick={() => setEditMode(!editMode)}
                    >
                      <img src={AppPics.EditSvg} alt="" />
                    </AppButton>
                  )}
                  {editMode && (
                    <AppButton
                      variantClass="lessonWrap__btn"
                      title="Save"
                      onClick={() => handleModification({ type: 'UPDATE' })}
                    >
                      <img src={AppPics.CheckSvg} alt="" />
                    </AppButton>
                  )}
                  <AppButton
                    variantClass="lessonWrap__btn"
                    title="Delete"
                    onClick={() =>
                      handleDeleteSModal({ show: true, data: { _id: selectedQuiz._id } })
                    }
                  >
                    <img src={AppPics.TrashBinSvg} alt="" />
                  </AppButton>
                  <Link
                    to={`/courses/${courseID}/chapters/${chapterID}/quizzes/${selectedQuiz._id}/questions`}
                  >
                    <AppButton variantClass="lessonWrap__btn" title="Go to">
                      <img src={AppPics.LinkSvg} alt="" />
                    </AppButton>
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(ManageQuiz);
